<template>
    <v-app :class="scssLocale">
        <loading-page v-show="this.$store.state.loading" />
            <v-fade-transition mode="out-in">
                <router-view />
            </v-fade-transition>
        <notification />
        <warning-modal />
    </v-app>
</template>

<script>
import LoadingPage from '@/components/LoadingPage'
import Notification from '@/components/Notification'
import WarningModal from '@/components/modal/WarningModal'

export default {
    name: 'App',

    components: {
        LoadingPage,
        Notification,
        WarningModal
    },

    computed: {
        scssLocale () {
            // switch to which scss by current language selected (global.scss)
            return this.$vuetify.lang.current + '-locale'
        }
    }
}
</script>

<style lang="scss">
.content-section {
    background-color: $white;
    position: absolute;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    width: calc(100% - 257px);
    right: 0;
    min-height: fit-content;
}
.content-section-line {
    height: 100vh;
}
.text-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 350px;
}
</style>
